"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var upgradeBrowserBaseTheme = function (_breakpoints) { return ({
    upgradeBrowserWrapper: {
        width: "440px",
        textAlign: "center",
        margin: "0 auto",
        backgroundColor: "white",
        borderTop: "5px solid #1e1e1e",
        padding: "3.25rem 1.5rem 3rem 1.5rem",
    },
    upgradeBrowserTitle: {
        marginTop: "3rem",
        marginBottom: "2rem",
        fontSize: "30px",
        fontWeight: "normal",
        color: "#292c2f",
    },
    upgradeBrowserSubtitle: {
        marginBottom: "2.25rem",
        fontSize: "20px",
        fontWeight: "normal",
        color: "#292c2f",
    },
    upgradeBrowserDownloadLink: {
        fontSize: "14px",
        fontWeight: "normal",
        margin: "0",
        color: "#009ad9",
        "& i18n-message": {
            textDecoration: "underline"
        }
    },
    upgradeBrowserLinks: {
        fontSize: "14px",
        fontWeight: "normal",
        color: "#292c2f",
    },
    upgradeBrowserLogoContainer: {
        display: "flex",
        justifyContent: "space-around",
        marginBottom: "3rem",
    },
    upgradeBrowserDownloadIcon: {
        "& a": {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            color: "#4299d4",
            fontSize: "20px",
        },
        "& img": {
            width: "auto",
            paddingBottom: "0.5rem",
            height: "72px",
        }
    },
    upgradeBrowserContainer: {
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "100%",
        display: "block",
        paddingTop: "160px",
    },
    upgradeBrowserLogo: {
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "inline-block",
    }
}); };
exports.default = upgradeBrowserBaseTheme;
//# sourceMappingURL=upgradeBrowser.js.map